import React, {
	Component
} from 'react';

import AppFooter from '../../components/app-footer/AppFooter';
import FormLogin from './components/form-login/FormLogin';
import RecuperarClave from './components/recuperarclave/RecuperarClave';
import ApiClient from '../../utils/ApiClient';
import UiUtils from '../../utils/UiUtils';
import Session from "../../utils/Session";
import UserDemo from './components/user-demo/UserDemo';
import lstrings from '../../utils/LStrings';
import TwoFactorForm from './components/two-factor-form/TwoFactorForm';
import SolicitarUsuario from './components/solicitarusuario/SolicitarUsuario';


class Home extends Component {

	initialState = {
		mostrarRecuperarClave: false,
		mostrarSolicitarUsuario: false,
		mostrarUserDemo: false,
		mostrarTwoFactor: false,
		username: null,
		password: null,
		twoFactorCode: null,
		counter: 0,
	}

	constructor() {
		super();

		this.state = { ...this.initialState }
	}

	/**
	 * Autenticación de usuario
	 *
	 * @param {String} username
	 * @param {String} password
	 *
	 */
	onLogin = (username, password) => {
		this.setState({ username, password })
		this.logear(username, password)
	}

	/**
	 * Autenticación de usuario
	 *
	 * @param {String|Number} twoFactorCode
	 *
	 */
	onTwoFactorCode = (code) => {
		this.logear(this.state.username, this.state.password, code)
	}


	logear = (username, password, twoFactorCode) => {
		UiUtils.showProgress(true);

		ApiClient.authenticate(username, password, twoFactorCode)
			.then((res) => {
				UiUtils.showProgress(false);
				if (res.success === true) {
					ApiClient.getAccount()
						.then((res) => {
							if (res.result.code === 200) {
								Session.setAccount(res.data);
								document.title = Session.getCompanyName();

								UiUtils.navigateTo('/dashboard/personas');
							} else {
								throw UiUtils.handledError(res.result.info);
							}
						})
						.catch((error) => {
							UiUtils.showError(error);
						});
				} else {
					throw new Error(res.reason);
				}
			}).catch((error) => {
				UiUtils.showProgress(false);
				var msg, title = "Error"
				if (!error.status && error.message) {
					msg = error.message
				}
				else {
					switch (error.status) {
						case 401:
							switch (error.message) {

								case "UsuarioSinServicioVigenteException":
									msg = lstrings.loginServiceExpiredException;
									break;
								case "UsuarioSinCreditosException":
									msg = lstrings.loginCreditsException;
									break;

								case "AccountExpiredException":
									msg = lstrings.loginAccountExpiredException;
									break;

								case "LockedException":
									msg = lstrings.loginLockedException;
									break;

								case "CredentialsExpiredException":
									msg = lstrings.loginCredentialsExpiredException;

									ApiClient.createSecurePassword(username)
										.then((res) => {
											UiUtils.showProgress(false);
											title = "Aviso"
											msg = "Revise su casilla de correo electrónico, habrá recibido un nuevo mensaje con las instrucciones para cambiar su clave"
										}).catch((error) => {
											UiUtils.showProgress(false);
											title = "Aviso"
											msg = "La cuenta tiene una solicitud de restablecimiento de contraseña. Compruebe su casilla de correo electrónico."
										});
									break;

								case "DisabledException":
									msg = lstrings.loginDisabledException;
									break;

								case "BadCredentialsException":
									if (error.attempts && error.attempts < 1) {
										msg = lstrings.loginBlockedException;
									}
									else {
										msg = `${lstrings.loginBadCredentialsException} ${
											error.attempts
												? `Le ${error.attempts == 1 ? 'queda 1 intento' : `quedan ${error.attempts} intentos.`}`
												: ''
										}`;
									}

									break;

								case "AccessDeniedByIpException":
									msg = lstrings.loginAccessDeniedByIpException;
									break;

								case "TotpRequiredException":
									if (this.state.mostrarTwoFactor) {
										if (error.attempts < 1) {
											msg = lstrings.loginBlockedException;
										}
										else {
											msg = lstrings.invalid_two_factor_code
												+ ` Le ${error.attempts == 1 ? `queda 1 intento` : `quedan ${error.attempts} intentos`}`;
										}
										break
									} else {
										this.mostrarTwoFactor()
										return
									}

								default:
									console.log("Exception", error)
									msg = lstrings.loginFailed;
							}
							break;

						case 412:
							msg = lstrings.serverResponsePreconditionFailed;
							break;

						case 500:
						case 502:
							msg = lstrings.serverResponse500;
							break;

						default:
							console.log("Exception", error)
							msg = lstrings.loginFailed;
					}
				}

				UiUtils.showAlert(title, msg);
			});
	}

	mostrarRecuperarClave = () => {
		this.setState({
			mostrarRecuperarClave: true
		});
	}
	mostrarSolicitarUsuario = () => {
		this.setState({
			mostrarSolicitarUsuario: true
		});
	}

	cerrarRecuperarClave = () => {
		this.setState({
			mostrarRecuperarClave: false
		});
	}
	cerrarSolicitarUsuario = () => {
		this.setState({
			mostrarSolicitarUsuario: false
		});
	}
	mostrarUserDemo = () => {
		this.setState({
			mostrarUserDemo: true
		});
	}

	mostrarTwoFactor = () => {
		this.setState({
			mostrarTwoFactor: true
		});
	}

	cerrarUserDemo = () => {
		this.setState({
			mostrarUserDemo: false
		});
	}

	handleGoBack = () => {
		this.setState({ ...this.initialState });
	}

	render() {

		return (
			<div>
				<div className="wrapper-home">
					<RecuperarClave
						mostrarRecuperarClave={this.state.mostrarRecuperarClave}
						onCerrarRecuperarClave={this.cerrarRecuperarClave} />
					<SolicitarUsuario
						mostrarSolicitarUsuario={this.state.mostrarSolicitarUsuario}
						onCerrarSolicitarUsuario={this.cerrarSolicitarUsuario}
					/>
					<UserDemo
						mostrarUserDemo={this.state.mostrarUserDemo}
						onCerrarUserDemo={this.cerrarUserDemo} />

					{!this.state.mostrarTwoFactor && (<FormLogin
						onMostrarRecuperarClave={this.mostrarRecuperarClave}
						onLogin={this.onLogin}
						onMostrarUserDemo={this.mostrarUserDemo}
						onMostrarSolicitarUsuario={this.mostrarSolicitarUsuario}

					/>)}

					{this.state.mostrarTwoFactor &&
						<TwoFactorForm
							onTwoFactorCode={this.onTwoFactorCode}
							onGoBack={this.handleGoBack}
						/>
					}
				</div>
				<div className="clearfix" />
				<AppFooter />
			</div>
		);
	}
}

export default Home;



// WEBPACK FOOTER //
// ./src/scenes/home/Home.js